// Serializer for ReservationContact (Person or Company) to backend DTO wrappers

import {
  ReservationContact,
  ReservationPerson as ReservationPersonSymbol,
  ReservationCompany as ReservationCompanySymbol
} from "./types";

import { serializeReservationPerson, type ReservationPersonDto } from "./model.ReservationPerson";
import {
  serializeReservationCompany,
  type ReservationCompanyDtoWrapper
} from "./model.ReservationCompany";

// Outbound DTOs used by SaveReservationRequest
export interface ReservationContactDto {
  Type: "Person" | "Company";
  Value: ReservationPersonContactDto | ReservationCompanyContactDto;
}

export interface ReservationPersonContactDto {
  Person: ReservationPersonDto;
}

export interface ReservationCompanyContactDto {
  Company: ReservationCompanyDtoWrapper;
}

export function serializeReservationContact(contact: ReservationContact | null): ReservationContactDto | null {
  if (!contact) {
    return null;
  }

  const isPerson = (contact as any)[ReservationPersonSymbol] === true;
  const isCompany = (contact as any)[ReservationCompanySymbol] === true;

  if (isPerson) {
    const personDto = serializeReservationPerson(contact as any);
    if (!personDto) {
      return null;
    }
    return {
      Type: "Person",
      Value: { Person: personDto }
    };
  }

  if (isCompany) {
    const companyDto = serializeReservationCompany(contact as any);
    if (!companyDto) {
      return null;
    }
    return {
      Type: "Company",
      Value: { Company: companyDto }
    };
  }

  return null;
}